/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_ErrorInputs */

const en_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to open billing portal`)
};

const de_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnungsportal konnte nicht geöffnet werden`)
};

const fr_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'ouvrir le portail de facturation`)
};

const es_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo abrir el portal de facturación`)
};

const it_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile aprire la porta di fatturazione`)
};

const nl_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mislukt om facturatieportaal te openen`)
};

const pl_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się otworzyć portalu płatności`)
};

const fi_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksamaksuportin avaaminen epäonnistui`)
};

const da_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke åbne faktureringsportalen`)
};

const sv_settings_billing_error = /** @type {(inputs: Settings_Billing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att öppna faktureringsportalen`)
};

/**
* | output |
* | --- |
* | "Failed to open billing portal" |
*
* @param {Settings_Billing_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_billing_error = /** @type {((inputs?: Settings_Billing_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_billing_error(inputs)
	if (locale === "fr") return fr_settings_billing_error(inputs)
	if (locale === "es") return es_settings_billing_error(inputs)
	if (locale === "it") return it_settings_billing_error(inputs)
	if (locale === "nl") return nl_settings_billing_error(inputs)
	if (locale === "pl") return pl_settings_billing_error(inputs)
	if (locale === "fi") return fi_settings_billing_error(inputs)
	if (locale === "da") return da_settings_billing_error(inputs)
	if (locale === "sv") return sv_settings_billing_error(inputs)
	return en_settings_billing_error(inputs)
});